export enum LegalEventType {
  SIGN_IN = 'SIGN_IN',
  TOS_ACCEPTANCE = 'TOS_ACCEPTANCE',
  TOS_DECLINAL = 'TOS_DECLINAL',
  SIGN_OUT = 'SIGN_OUT',
}
